import { INode } from '@cbridge-packages/node';
import { IServer } from '@cbridge-packages/server';

export enum ClientSymbolListMode {
  Basic = 'Basic',
  Detailed = 'Detailed',
  Pricing = 'Pricing',
  Routing = 'Routing',
}

export interface ISymbolClientDataGridProps {
  nodeId: INode['nodeId'];
  serverId: IServer['serverId'];
  mode: ClientSymbolListMode;
}

export enum ClientSymbolColumnFilterNames {
  symbolGroup = 'symbolGroup',
  stream = 'stream',
}

export enum ClientSymbolQuickFilterNames {
  search = 'search',
  filter = 'filter',
  include = 'include',
}
